const AppEnv = {
    baseApiUrl: "/api"
};
export default AppEnv;